import { defineStore } from 'pinia';
import api from '../../api';

export const useMulticastStore = defineStore('multicast', {
  state: () => ({
    tableList: [],
    tableListUpdated: false,
    total: 0,
    modePortList: { physicalPort: [], lagPort: [] },
    isMulticastModePortListUpdated: false,
    blockAddressList: [],
    blockAddressListUpdated: false,
  }),

  actions: {
    queryMulticastList(params) {
      return api.multicast.queryMulticastList(params)
        .then(json => {
          if (json.resp.respCode === 0) {
            this.setMultiCastGroups(json.multicastGroups);
          }
          return json;
        })
        .catch(error => {
          throw error;
        });
    },
    setMultiCastGroups(data){
      this.total = parseInt(data.total)
      this.tableList = data.rows || [];
      this.tableListUpdated = true;
    },

    queryMulticastModeInfo() {
      return api.multicast.queryMulticastModeInfo()
        .then(data => {
          if((data.resp.respCode === 0)  && data.multicastModeConfig){
            this.setModePortList(data.multicastModeConfig);
          }
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
    setModePortList(data){
      this.modePortList = data;
      this.isMulticastModePortListUpdated = true;
    },
    queryMulticastBlockAddressInfo() {
      return api.multicast.queryMulticastBlockAddressInfo()
        .then(data => {
          if (data.resp.respCode === 0) {
            this.setBlockAddressList(data.blockAddressList);
          }
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
    setBlockAddressList(data){
      this.blockAddressList = data;
      this.blockAddressListUpdated = true;
    },
    updateMulticastMode(params) {
      return api.multicast.updateMulticastMode(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },

    updateMulticastBlockAddress(params) {
      return api.multicast.updateMulticastBlockAddress(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    }
  }
});
